export const textSizeOptions = {
  xs: "text-xs",
  sm: "text-sm",
  md: "text-md",
  lg: "text-lg",
  xl: "text-xl"
};

export const textVariantOptions = {
  primary: "text-primary",
  secondary: "text-secondary",
  success: "text-success",
  info: "text-info",
  warning: "text-warning",
  danger: "text-danger",
  light: "text-light",
  dark: "text-dark",
  lightblue: "text-lightblue",
  navy: "text-navy",
  olive: "text-olive",
  lime: "text-lime",
  fuchsia: "text-fuchsia",
  maroon: "text-maroon",
  blue: "text-blue",
  indigo: "text-indigo",
  purple: "text-purple",
  pink: "text-pink",
  red: "text-red",
  orange: "text-orange",
  yellow: "text-yellow",
  green: "text-green",
  teal: "text-teal",
  cyan: "text-cyan",
  white: "text-white",
  gray: "text-gray",
  graydark: "text-gray-dark"
};

export const btnVariantOptinos = {
  dark: "btn-dark",
  light: "btn-light",
  default: "btn-default",
  primary: "btn-primary",
  secondary: "btn-secondary",
  success: "btn-success",
  info: "btn-info",
  danger: "btn-danger",
  warning: "btn-warning",
  outlineDark: "btn-outline-dark",
  outlineLight: "btn-outline-light",
  outlinePrimary: "btn-outline-primary",
  outlineSecondary: "btn-outline-secondary",
  outlineSuccess: "btn-outline-success",
  outlineInfo: "btn-outline-info",
  outlineDanger: "btn-outline-danger",
  outlineWarning: "btn-outline-warning"
};

export const btnSizeOptions = {
  lg: "btn-lg",
  sm: "btn-sm",
  xs: "btn-xs"
};

export const btnTypeOptions = {
  button: "button",
  submit: "submit"
};

export const btnShapeOptions = {
  roundedFlat: "btn-flat",
  roundedPill: "rounded-pill",
  roundedCircle: "rounded-circle",
  roundedLg: "rounded-lg",
  roundedSm: "rounded-sm"
};

export const btnGroupSizeOptions = {
  sm: "btn-group-sm",
  lg: "btn-group-lg"
};

export const dropdownPlacementOptions = [
  "auto",
  "auto-start",
  "auto-end",
  "top",
  "top-start",
  "top-end",
  "bottom",
  "bottom-start",
  "bottom-end",
  "right",
  "right-start",
  "right-end",
  "left",
  "left-start",
  "left-end"
];

export const navDropdownDirectionOptions = {
  down: "dropdown",
  left: "dropleft",
  right: "dropright",
  up: "dropup",
  none: ""
};

export const navDropdownSizeOptions = {
  md: "dropdown-menu-md",
  lg: "dropdown-menu-lg",
  xl: "dropdown-menu-xl"
};

export const navDropdownMenuDirectionOptions = {
  right: "dropdown-menu-right",
  left: "dropdown-menu-left"
};

export const navDropdownShadowOptions = {
  shadow: "shadow",
  sm: "shadow-sm",
  lg: "shadow-lg",
  none: "shadow-none"
};

export const navbarVariantOpitons = {
  primary: "navbar-primary",
  secondary: "navbar-secondary",
  success: "navbar-success",
  info: "navbar-info",
  warning: "navbar-warning",
  danger: "navbar-danger",
  lightblue: "navbar-lightblue",
  navy: "navbar-navy",
  olive: "navbar-olive",
  lime: "navbar-lime",
  fuchsia: "navbar-fuchsia",
  maroon: "navbar-maroon",
  blue: "navbar-blue",
  indigo: "navbar-indigo",
  purple: "navbar-purple",
  pink: "navbar-pink",
  red: "navbar-red",
  orange: "navbar-orange",
  yellow: "navbar-yellow",
  green: "navbar-green",
  teal: "navbar-teal",
  cyan: "navbar-cyan",
  white: "navbar-white",
  gray: "navbar-gray",
  graydark: "navbar-gray-dark"
};

export const sidebarBrandVariantOptions = {
  primary: "navbar-primary",
  secondary: "navbar-secondary",
  success: "navbar-success",
  info: "navbar-info",
  warning: "navbar-warning",
  danger: "navbar-danger",
  lightblue: "navbar-lightblue",
  light: "navbar-light",
  dark: "navbar-dark",
  navy: "navbar-navy",
  olive: "navbar-olive",
  lime: "navbar-lime",
  fuchsia: "navbar-fuchsia",
  maroon: "navbar-maroon",
  blue: "navbar-blue",
  indigo: "navbar-indigo",
  purple: "navbar-purple",
  pink: "navbar-pink",
  red: "navbar-red",
  orange: "navbar-orange",
  yellow: "navbar-yellow",
  green: "navbar-green",
  teal: "navbar-teal",
  cyan: "navbar-cyan",
  white: "navbar-white",
  gray: "navbar-gray",
  graydark: "navbar-gray-dark"
};

export const sidebarElevationOptions = {
  sm: "elevation-1",
  md: "elevation-2",
  lg: "elevation-3",
  xl: "elevation-4"
};

export const sidebarContainerVariantOpitons = {
  darkPrimary: "sidebar-dark-primary",
  darkWarning: "sidebar-dark-warning",
  darkInfo: "sidebar-dark-info",
  darkDanger: "sidebar-dark-danger",
  darkSuccess: "sidebar-dark-success",
  darkIndigo: "sidebar-dark-indigo",
  darkLightblue: "sidebar-dark-lightblue",
  darkNavy: "sidebar-dark-navy",
  darkPurple: "sidebar-dark-purple",
  darkFuchsia: "sidebar-dark-fuchsia",
  darkPink: "sidebar-dark-pink",
  darkMaroon: "sidebar-dark-maroon",
  darkOrange: "sidebar-dark-orange",
  darkLime: "sidebar-dark-lime",
  darkTeal: "sidebar-dark-teal",
  darkOlive: "sidebar-dark-olive",
  lightPrimary: "sidebar-light-primary",
  lightWarning: "sidebar-light-warning",
  lightInfo: "sidebar-light-info",
  lightDanger: "sidebar-light-danger",
  lightSuccess: "sidebar-light-success",
  lightIndigo: "sidebar-light-indigo",
  lightLightblue: "sidebar-light-lightblue",
  lightNavy: "sidebar-light-navy",
  lightPurple: "sidebar-light-purple",
  lightFuchsia: "sidebar-light-fuchsia",
  lightPink: "sidebar-light-pink",
  lightMaroon: "sidebar-light-maroon",
  lightOrange: "sidebar-light-orange",
  lightLime: "sidebar-light-lime",
  lightTeal: "sidebar-light-teal",
  lightOlive: "sidebar-light-olive"
};

export const sidebarNavShapeOptions = {
  pill: "nav-pills",
  flat: "nav-flat",
  legacy: "nav-legacy",
  compact: "nav-compact"
};

export const switchVariantOptions = {
  off: {
    primary: "custom-switch-off-primary",
    secondary: "custom-switch-off-secondary",
    success: "custom-switch-off-success",
    info: "custom-switch-off-info",
    warning: "custom-switch-off-warning",
    danger: "custom-switch-off-danger",
    light: "custom-switch-off-light",
    dark: "custom-switch-off-dark",
    lightblue: "custom-switch-off-lightblue",
    navy: "custom-switch-off-navy",
    olive: "custom-switch-off-olive",
    lime: "custom-switch-off-lime",
    fuchsia: "custom-switch-off-fuchsia",
    maroon: "custom-switch-off-maroon",
    blue: "custom-switch-off-blue",
    indigo: "custom-switch-off-indigo",
    purple: "custom-switch-off-purple",
    pink: "custom-switch-off-pink",
    red: "custom-switch-off-red",
    orange: "custom-switch-off-orange",
    yellow: "custom-switch-off-yellow",
    green: "custom-switch-off-green",
    teal: "custom-switch-off-teal",
    cyan: "custom-switch-off-cyan",
    white: "custom-switch-off-white",
    gray: "custom-switch-off-gray",
    graydark: "custom-switch-off-gray-dark"
  },
  on: {
    primary: "custom-switch-on-primary",
    secondary: "custom-switch-on-secondary",
    success: "custom-switch-on-success",
    info: "custom-switch-on-info",
    warning: "custom-switch-on-warning",
    danger: "custom-switch-on-danger",
    light: "custom-switch-on-light",
    dark: "custom-switch-on-dark",
    lightblue: "custom-switch-on-lightblue",
    navy: "custom-switch-on-navy",
    olive: "custom-switch-on-olive",
    lime: "custom-switch-on-lime",
    fuchsia: "custom-switch-on-fuchsia",
    maroon: "custom-switch-on-maroon",
    blue: "custom-switch-on-blue",
    indigo: "custom-switch-on-indigo",
    purple: "custom-switch-on-purple",
    pink: "custom-switch-on-pink",
    red: "custom-switch-on-red",
    orange: "custom-switch-on-orange",
    yellow: "custom-switch-on-yellow",
    green: "custom-switch-on-green",
    teal: "custom-switch-on-teal",
    cyan: "custom-switch-on-cyan",
    white: "custom-switch-on-white",
    gray: "custom-switch-on-gray",
    graydark: "custom-switch-on-gray-dark"
  }
};

export const switchSizeOptions = {
  sm: "nly-custom-control-sm",
  lg: "nly-custom-control-lg"
};

export const bgVariantOptions = {
  primary: "bg-primary",
  secondary: "bg-secondary",
  success: "bg-success",
  info: "bg-info",
  warning: "bg-warning",
  danger: "bg-danger",
  light: "bg-light",
  dark: "bg-dark",
  lightblue: "bg-lightblue",
  navy: "bg-navy",
  olive: "bg-olive",
  lime: "bg-lime",
  fuchsia: "bg-fuchsia",
  maroon: "bg-maroon",
  blue: "bg-blue",
  indigo: "bg-indigo",
  purple: "bg-purple",
  pink: "bg-pink",
  red: "bg-red",
  orange: "bg-orange",
  yellow: "bg-yellow",
  green: "bg-green",
  teal: "bg-teal",
  cyan: "bg-cyan",
  white: "bg-white",
  gray: "bg-gray",
  graydark: "bg-gray-dark"
};

export const bgGradientOptions = {
  primary: "bg-gradient-primary",
  secondary: "bg-gradient-secondary",
  success: "bg-gradient-success",
  info: "bg-gradient-info",
  danger: "bg-gradient-danger",
  warning: "bg-gradient-warning",
  light: "bg-gradient-light",
  dark: "bg-gradient-dark",
  lightblue: "bg-gradient-lightblue",
  navy: "bg-gradient-navy",
  olive: "bg-gradient-olive",
  lime: "bg-gradient-lime",
  fuchsia: "bg-gradient-fuchsia",
  maroon: "bg-gradient-maroon",
  blue: "bg-gradient-blue",
  indigo: "bg-gradient-indigo",
  purple: "bg-gradient-purple",
  pink: "bg-gradient-pink",
  red: "bg-gradient-red",
  orange: "bg-gradient-orange",
  yellow: "bg-gradient-yellow",
  green: "bg-gradient-green",
  teal: "bg-gradient-teal",
  cyan: "bg-gradient-cyan",
  white: "bg-gradient-white",
  gray: "bg-gradient-gray",
  graydark: "bg-gradient-gray-dark"
};

export const cardGroupTypeOption = {
  default: "card-group",
  deck: "card-deck",
  columns: "card-columns",
  accordion: "accordion"
};

export const cardVariantOptions = {
  primary: "card-primary",
  secondary: "card-secondary",
  succes: "card-succes",
  info: "card-info",
  warning: "card-warning",
  danger: "card-danger",
  light: "card-light",
  dark: "card-dark",
  lightblue: "card-lightblue",
  navy: "card-navy",
  olive: "card-olive",
  lime: "card-lime",
  fuchsia: "card-fuchsia",
  maroon: "card-maroon",
  blue: "card-blue",
  indigo: "card-indigo",
  purple: "card-purple",
  pink: "card-pink",
  red: "card-red",
  orange: "card-orange",
  yellow: "card-yellow",
  green: "card-green",
  teal: "card-teal",
  cyan: "card-cyan",
  white: "card-white",
  gray: "card-gray",
  graydark: "card-gray-dark"
};

export const badgeVariantOptions = {
  primary: "badge-primary",
  secondary: "badge-secondary",
  success: "badge-success",
  info: "badge-info",
  warning: "badge-warning",
  danger: "badge-danger",
  light: "badge-light",
  dark: "badge-dark"
};

export const inputTypeOptions = [
  "text",
  "password",
  "email",
  "number",
  "url",
  "tel",
  "search",
  "range",
  "color",
  "date",
  "time",
  "datetime",
  "datetime-local",
  "month",
  "week"
];

export const inputMaxMinStepOptions = [
  "number",
  "range",
  "date",
  "datetime",
  "datetime-local",
  "month",
  "time",
  "week"
];

export const formValidOptions = ["valid", "invalid", "warning", "novalid"];

export const formFeedBackValidOptions = {
  valid: "valid-feedback",
  invalid: "invalid-feedback",
  warning: "warning-feedback"
};

export const formFeedBackTooltipOptions = {
  valid: "valid-tooltip",
  invalid: "invalid-tooltip",
  warning: "warning-tooltip"
};

export const breakPointValidOptions = ["xs", "sm", "md", "lg", "lx"];

export const breakPointOptions = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};
